import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/SimbaStickers_Logo.png'


const _withScopeId = n => (_pushScopeId("data-v-74d73db7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Simba Stickers logo",
    src: _imports_0
  })
], -1))
const _hoisted_2 = { class: "welcome" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 data-v-74d73db7>Welcome to Simba Stickers!</h1><p data-v-74d73db7> We run an <a href=\"https://shop.simbastickers.com\" data-v-74d73db7>online store</a>, at <a href=\"https://shop.simbastickers.com\" data-v-74d73db7>shop.simbastickers.com</a>, in association with <a href=\"https://sellfy.com\" aria-label=\"\" data-v-74d73db7>Sellfy</a>. </p><p data-v-74d73db7>Before long there will be a dedicated storefront to that shop at this address, enabling for much easier searching of our vast catalogue of digital and print-on-demand products.</p><p data-v-74d73db7>Until then, we kindly invite you to shop directly from <a href=\"https://shop.simbastickers.com\" data-v-74d73db7>shop.simbastickers.com</a>, which is fully functional.</p><p data-v-74d73db7>If you would like to be informed upon release of our website, kindly sign up for our newsletter on the <a href=\"https://shop.simbastickers.com\" data-v-74d73db7> store</a>!</p>", 5)
const _hoisted_8 = { class: "go_to_store" }
const _hoisted_9 = { href: "https://shop.simbastickers.com" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, [
  /*#__PURE__*/_createTextVNode("Go to "),
  /*#__PURE__*/_createElementVNode("b", null, "shop.simbastickers.com")
], -1))
const _hoisted_11 = { class: "redirect" }

import { defineComponent } from 'vue';
import Countdown from '@/components/Countdown.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'     ;
import { faHouse, faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons' ;

const durationBeforeRedirection = 1;

export default /*#__PURE__*/_defineComponent({
  __name: 'SplashPage',
  setup(__props) {

const redirectToShop = () => {
  console.info('Redirecting!');
  window.location.href = 'https://shop.simbastickers.com';
};
redirectToShop(); // We want to do it immediately.


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_8, [
        _createElementVNode("a", _hoisted_9, [
          _hoisted_10,
          _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faArrowRightFromBracket) }, null, 8, ["icon"])
        ])
      ]),
      _createElementVNode("p", _hoisted_11, [
        _createTextVNode("You will be redirected in "),
        _createVNode(Countdown, {
          duration: durationBeforeRedirection,
          callback: redirectToShop
        }),
        _createTextVNode(" seconds. ")
      ])
    ])
  ], 64))
}
}

})